import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  state() {
    return {
      contactInfo: {},
    };
  },
  mutations,
  actions,
  getters,
  namespaced: true,
};
